export default __webpack_public_path__ + "static/media/convenience_video.cb0bc5dd.jpg";